export default "__VITE_ASSET__v2bZ_sTg__"